import React from 'react'

const FacebookIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.9149 0H3.24821C1.78154 0 0.581543 1.2 0.581543 2.66667V21.3333C0.581543 22.8013 1.78154 24 3.24821 24H12.5815V14.6667H9.91488V11.3667H12.5815V8.63333C12.5815 5.748 14.1975 3.72133 17.6029 3.72133L20.0069 3.724V7.19733H18.4109C17.0855 7.19733 16.5815 8.192 16.5815 9.11467V11.368H20.0055L19.2482 14.6667H16.5815V24H21.9149C23.3815 24 24.5815 22.8013 24.5815 21.3333V2.66667C24.5815 1.2 23.3815 0 21.9149 0Z"
        fill="#373843"
      />
    </svg>
  )
}

export default FacebookIcon
